import { ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export function HelpfulButton({ review, onVoted }) {
  const vote = async () => {
    try { await api.post(`/reviews/${review.id}/helpful`); onVoted?.(); } catch (e) { toast.error(errorMessage(e)); }
  };
  if (review.mine) {
    return review.helpful_count > 0
      ? <p data-testid={`review-helpful-count-${review.id}`} className="mt-2 text-xs text-slate-500">{review.helpful_count} found this helpful</p>
      : null;
  }
  return (
    <button data-testid={`review-helpful-${review.id}`} onClick={vote}
      className={`mt-2 flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border transition-colors ${review.voted ? "border-[#00E5A3] bg-[#00E5A3]/10 text-[#00E5A3]" : "border-[#26334D] text-slate-400 hover:text-white hover:border-slate-500"}`}>
      <ThumbsUp className={`h-3.5 w-3.5 ${review.voted ? "fill-current" : ""}`} /> Helpful{review.helpful_count > 0 ? ` · ${review.helpful_count}` : ""}
    </button>
  );
}
